<tt-page>
    <tt-page-heading ttModel="p2_m_about" ttTranslate></tt-page-heading>
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-about></tt-about>
    </tt-card>
</tt-page>
